import React from "react";
import {
  Typography,
  CircularProgress,
  TableCell,
  TableRow,
} from "@mui/material";

interface Props {
  text: string;
  spinnerSize?: number;
  spinnerClass?: string;
  textClass?: string;
  noResults?: boolean;
  table?: boolean;
}
export default function LoadingIndicator({
  text,
  spinnerSize,
  spinnerClass,
  textClass,
  noResults,
  table,
}: Props) {
  const loadingIndicator = noResults ? (
    <Typography
      variant="body2"
      component="div"
      color="primary"
      className={textClass}
    >
      No Results
    </Typography>
  ) : (
    <>
      <Typography
        variant="body2"
        component="div"
        color="primary"
        className={spinnerClass}
      >
        <CircularProgress disableShrink size={spinnerSize ? spinnerSize : 20} />
      </Typography>
      <Typography
        variant="body2"
        component="div"
        color="primary"
        className={textClass}
      >
        {text}
      </Typography>
    </>
  );
  return table ? (
    <TableRow>
      <TableCell
        colSpan={100}
        // style={{ position: "absolute", width: "100%", backgroundColor: "#fff" }}
      >
        {loadingIndicator}
      </TableCell>
    </TableRow>
  ) : (
    loadingIndicator
  );
}
